<template>
  <div>
    <div class="ubt-nav flex justify-content-between">
      <div class="search inline-block" style="width:100%">
        <div style="display: flex" @click="camChooser = true">
            <feather
            type="filter"
          ></feather>
          <!-- <filter-icon size="1.5x" style="margin-right: 5px;"></filter-icon> -->
          <span
            style="
    width: 100%;
    text-align: left;
    /* display: block; */
    /* flex-grow: 1; */
"
            >Камер сонгох</span
          >
        </div>
      </div>
      <div class="nav" @click="showMenu()">
        <feather
            type="menu"
          ></feather>
        <!-- <menu-icon size="1.5x" class="custom-class"></menu-icon> -->
      </div>
    </div>

    <GmapMap ref="baseMap" 
        :center="gmap.center"
        :zoom="16"
        map-type-id="roadmap"
        style="width: 100%; height: 100vh"

        :options="{
          minZoom: 13, 
          maxZoom: 18,
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUI: false
        }"
      >
      <!-- <GMapCluster :minimumClusterSize="2" > -->
        <GmapMarker
          style="color: green"
          :icon="`${m.icon}`"
          @click="toggleInfoWindow(m, i)"
          v-for="(m, i) in googleMapMaker"
          :key="i"
          :position="m.position"
          :title="m.title"
        />
      <!-- </GMapCluster> -->
    </GmapMap>
    <b-modal  v-model="camChooser" @hide="onMdlCamChooserHide" title="Камер сонгоно уу" dialog-class="full-scrn" scrollable>
      <template #modal-header="{ close }">
        <h6>Камер сонгоно уу</h6>
        <b-button size="sm" variant="outline-danger" @click="close()">
          <!-- <x-icon></x-icon> -->
          <feather type="x"></feather>
        </b-button>
      </template>

      <b-list-group>
        <b-list-group-item @click="camChooser=false; setMapCenter(c.position); toggleInfoWindow(c, ci)" v-for="(c, ci) in googleMapMaker.filter(x=>!x.person)" button :key="`frmc_${ci}`"
          class="d-flex">
          <div class="text-muted" style="margin-right: 10px">
            <!-- <video-icon style="width: 16px; height:16px"></video-icon> -->
            <feather type="video" style="width: 16px; height:16px"></feather>
          </div>
          <span style="font-size: 14px">
            {{c.title}}
          </span>
        </b-list-group-item>
      </b-list-group>
      <template #modal-footer>
        <b-button-group size="sm" class="w-100">
          <b-button @click="changeOrderMode(1)" :variant="`${orderedMode==1?'primary':'outline-primary'}`" class="w-50 d-flex text-center">
            <chevron-down-icon size="1.5x" class="float-left"></chevron-down-icon> Нэршлээр
          </b-button>
          <b-button @click="changeOrderMode(2)" :variant="`${orderedMode==2?'primary':'outline-primary'}`" class="w-50 d-flex text-center">
            <chevron-down-icon size="1.5x" class="float-left"></chevron-down-icon>Надад ойр
          </b-button>
        </b-button-group>
      </template>
    </b-modal>
    <b-modal  v-model="modalCam.show" @hide="onMdlHide" :title="modalCam.title" centered hide-footer no-close-on-backdrop body-class="no-pdng" hide-backdrop
    scrollable>

    <template #modal-header="{ close }">
      <h6>{{modalCam.title}}</h6>
      <b-button size="sm" variant="outline-danger" @click="close()">
        <feather type="x"></feather>
      </b-button>
    </template>

      <video id="vid1" class="video-js" style="width: 100%; height: calc(100vw/1.28)">
      </video>
      <div @click="playCamera()" v-show="!isPLaying" class="plybtn">
        <!-- <video-icon size="4x" style="width: 96px; height: 96px; color: white; text-shadow: 2px 2px #666;"></video-icon> -->
        <feather type="video" size="4" style="width: 96px; height: 96px; color: white; text-shadow: 2px 2px #666;"></feather>
      </div>
      <div class="plysec" v-show="maxTime>currentTime && currentTime>0">
         {{maxTime-currentTime}} сек
      </div>
      <b-list-group>
        <b-list-group-item @click="camChanged(); setMapCenter(c.position); toggleInfoWindow(c, ci)" v-for="(c, ci) in closestMapMarkers" 
          button :key="`frmc_${ci}`" class="d-flex" >
          <div class="text-muted" style="margin-right: 10px">
            <feather type="video"  style="width: 16px; height:16px"></feather>
            <!-- <video-icon style="width: 16px; height:16px"></video-icon> -->
          </div>
          <span style="font-size: 14px">
            {{c.title}}
          </span>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
//import Vue from 'vue'
//Vue.use(VueGoogleMaps, {})
//import * as VueGoogleMaps from 'vue2-google-maps'

var _ = require("lodash");
import Hls from 'hls.js';
const hls = new Hls();
import { mapActions } from "vuex";

export default {

    
  data() {
    return {
      token:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI4OGVkNDU3Ni03MGVkLTRiYzQtOTQ4OC1iNDY5YzAzMWVhZjUiLCJ1c2VybmFtZSI6InViaXRzLm1uIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbmFtZSI6InViaXRzLm1uIiwic2lkIjoiOTkiLCJqdGkiOiIxNjIyYmM3ZS0wY2Q3LTRlNDMtYTEzYS1iZjJjNTUyNWM4NjkiLCJuYmYiOjE2NjQ3NzkzMTgsImV4cCI6MTk4MDEzOTMxOCwiaXNzIjoiZHluYW1pY0FwaSIsImF1ZCI6ImR5bmFtaWNBcGkifQ.3kNn7IJK063YZvCnC_N9pjo9F9MJRL8BNwRt7Fu6mA4",
      toggler: {
        showStops: false,
        showCustom: false,
      },
      rightMenu: false,
      markersFetched: false,
      timer: null,
      mapRdy: false,
      maxTime: 20,
      currentTime: 0,
      intrvl: null,
      orderedMode: 1,
      showFtr: false,
      camChooser: false,
      isPLaying: false,
      gmap: {
        center: {
          lat: 47.92324766734612,
          lng: 106.91819033071897,
        },
        me: {
          lat: null,
          lng: null,
        },
      },
      serverMapMaker: [],
      googleMapMaker: [],
      closestMapMarkers: [],
      modalCam: {
        title: null,
        prt: null,
        sec: null,
        show: false,
      },
      modalInf: {
        title: null,
        desc: null,
        show: false,
      },
    };
  },
  mounted(){
    let self= this;

    this.$refs.baseMap.$mapPromise.then((map) => {
            // map.panTo(self.gmap.me);

            // self.googleMapMaker.push({
            //   title: 'my loc',
            //   position: self.gmap.me,
            //   icon: 'https://res.gosmart.mn/media/icon/markeruser.png?w=32',
            //   person: true,
            //   stops: false,
            // });

            if(window.google!=undefined){
              //console.log("hey ene bol window")
              const trafficLayer = new window.google.maps.TrafficLayer();
              trafficLayer.setMap(map);
            }
            // else{
            //   console.log('s1');
            //   self.timer = setInterval(() => {
            //     console.log('tiking');
            //     if(window.google!=undefined) {
            //       clearInterval(self.timer);
            //       const trafficLayer = new window.google.maps.TrafficLayer();
            //       trafficLayer.setMap(map);
            //     }else{

            //       self.loadAftre(map)
            //     }
            //   }, 3000)

            // }

            self.loadMarkers();
          })
  },
  methods:{
    ...mapActions([
      "handleResponsiveLayoutConfig"
    ]),
    changeOrderMode(mode){
      this.orderedMode= mode;
      if(mode==1){
        this.googleMapMaker= _.orderBy(this.googleMapMaker, ["title"], ["asc"])
      }else if(mode==2){
        this.find_closest_marker(this.gmap.me);
        this.googleMapMaker= _.orderBy(this.googleMapMaker, ["distance"], ["asc"])
      }
    },
    setMapCenter(location){
      //console.log('location', location);
      this.gmap.center= location;
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    showMenu(){
        
      let _obj = this.$store.state.app.responsiveLayout;
      _obj.navbarNavShow = true;
      _obj.backdrop.show = true;
      _obj.backdrop.onCloseEvent = 1;
      _obj.backdrop.removeClassName = "navbar-nav-show";
      this.handleResponsiveLayoutConfig(_obj).then(() => {
        this.toggleBodyClass("addClass", "navbar-nav-show");
        this.toggleBodyClass("addClass", "show-aside");
      });
    
    
},
    playCamera(){
      let self= this;
      var video = document.getElementById('vid1');
      video.play();
      this.isPLaying= true;

      clearInterval(this.intrvl);
      this.currentTime= 0;

      this.intrvl= setInterval(function () {
        if(self.currentTime>=self.maxTime){
          self.onMdlHide();
        }else{
          self.currentTime++;
        }
      }, 1000);
    },
    onMdlCamChooserHide(){
      this.camChooser= false;
    },
    toggleInfoWindow(mrkr){
      // console.log('marker', mrkr.port, mrkr);
      this.showFtr= false;

      if(mrkr.person!=undefined && mrkr.person){
        return;
      }
      else if((mrkr.stops!=undefined && mrkr.stops)
      ||
      (mrkr.custom!=undefined && mrkr.custom)
      ){
        this.modalInf.title= mrkr.title;
        this.modalInf.desc= mrkr.desc;
        this.modalInf.show= true;
        // console.log('this.modalInf', this.modalInf, mrkr);
        return;
      }

      let self= this;
      self.modalCam.title= mrkr.title;
      this.modalCam.prt= mrkr.port;
      this.modalCam.sec= mrkr.sec;

      //this.gmap.center= mrkr.position;

      this.modalCam.show= true;

      this.$nextTick(() => {
        var video = document.getElementById('vid1');
        hls.loadSource(`https://stream.ubtraffic.mn/live/${mrkr.port}.stream_160p/playlist.m3u8`);
        hls.attachMedia(video);
      });      

      this.find_closest_marker(mrkr.position);

      this.postLogMarker(mrkr);
    },
    rad(x) {
      return x*Math.PI/180;
    },
    postLogMarker(mrkr){
      // console.log(mrkr);
      const config = { headers: { Authorization: `Bearer ${this.token}` } };
      axios.get('https://ubtraffic.mn/core/Task/viewLog?id='+mrkr.id, config );
    },
    find_closest_marker( event ) {
      var lat = event.lat;
      var lng = event.lng;
      var R = 6371; // radius of earth in km
      var distances = [];
      var closest = -1;

      let clnmapMarkers= this.googleMapMaker.filter(x=>!x.person);

      for(let i=0;i<clnmapMarkers.length; i++ ) {
          var mlat = clnmapMarkers[i].position.lat;
          var mlng = clnmapMarkers[i].position.lng;
          var dLat  = this.rad(mlat - lat);
          var dLong = this.rad(mlng - lng);
          var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(this.rad(lat)) * Math.cos(this.rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
          var d = R * c;
          
          clnmapMarkers[i]['distance']= d;
          distances[i] = d;
          if ( closest == -1 || d < distances[closest] ) {
              closest = i;
          }
      }
      if(closest>-1){
        this.closestMapMarkers= _.pick(_.orderBy(clnmapMarkers, ["distance"], ["asc"]), [1,2,3]);
      }
      
    },
    camChanged(){
      this.isPLaying= false;

      hls.stopLoad();

      clearInterval(this.intrvl);
      this.currentTime= 0;
    },
    onMdlHide() {
      this.isPLaying= false;
      var player = document.getElementById('vid1');
      if (player) {
          player.pause();
          player.remove();
      }
      hls.stopLoad();

      clearInterval(this.intrvl);
      this.currentTime= 0;

      this.modalCam.show= false;
    },
    loadMarkers(){
      const config = { headers: { Authorization: `Bearer ${this.token}` } };

      axios.get('https://ubtraffic.mn/core/Task/cameraJson',config
      ).then(res=>{
        
        this.markersFetched= true;
        this.serverMapMaker= res.data.data.cameras;
        let cmrs= res.data.data.cameras.map((x) => {
              
          return {
            id: x.id,
            title: x.name.trim(),
            icon: 'https://res.gosmart.mn/media/icon/ubtraffic.png?w=32',
            position: {
              lat: parseFloat(x.lat),
              lng: parseFloat(x.lng),
            },
            port: x.port,
            distance: null,
            person: false,
            stops: false,
          }
        });

        cmrs= _.orderBy(cmrs, ["title"], ["asc"]);
        let mrged= _.merge(cmrs, this.googleMapMaker);
        this.googleMapMaker= mrged;

      });

      // axios
      // .get('https://adm.ubtraffic.mn/public/cameraJson?t=f')
      // .then(res => {
        
      // });
    },
  }
//   beforeMount () {
//     axios.get('https://taskdoc.gosmart.mn/ubtraffic/getoke').then(res => {
//       VueGoogleMaps.loadGmapApi({
//         key: res.data.data,
//         //libraries: 'places'
//         region: 'MN',
//         language: 'mn',
//       })
//     });
//   },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
.my-location{
  cursor: pointer;
  border-radius: 3px;
  background: white;
  position: absolute;
  right: 5px;
  bottom: 20px;
   padding: 8px;
}
.my-location img{
  width: 32px;
  height: 32px;
}
.no-pdng{
  position: relative;
  padding: 0 !important
}
.no-pdng .plybtn{
  position: absolute;
  top: 90px;
  left: calc(50vw - 60px);
  width: 120px;
  height: 100px;
  text-align: center;
  background: rgba(0,0,0,0.5);
  border-radius: 20px;
}
.plysec{
  position: absolute;
  top: 0px;
  right: 0px;
  color: orange;
  background: #FFF;
  padding: 0px 5px;
  border-radius: 0 0 0 5px;
}

.ubt-nav{
  padding: 10px 10px;
  margin: 10px 10px 5px 10px;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  border-radius: 5px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 999;
}
.ubt-nav .nav{
  margin-left: auto;
}
.full-scrn{
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
}

.ubt-footer{
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  border-radius: 5px 5px 0 0;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 0;
  z-index: 1038;
}
.ubt-footer .closen{
  position: absolute;
  right: 6px;
  top: -15px;
  border-radius: 5px 5px 0 0;
  background: rgba(255, 255, 255,0.9);
  padding: 7px;
  z-index: 999;
}
</style>